import React, { useId } from "react";
import { Box, Icon, type IconProps } from "@chakra-ui/react";

export function ConnectorLine(props: IconProps) {
  const id = useId();
  return (
    <Icon width="68px" height="4px" fill="none" viewBox="0 0 68 4" {...props}>
      <g filter={`url(#line-${id})`}>
        <Box as="path" stroke="new.blue.300" strokeWidth="2.835" d="M.53 2.02h66.63" />
      </g>
      <defs>
        <filter
          id={`line-${id}`}
          width="66.63"
          height="3.823"
          x=".53"
          y=".602"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy=".988" />
          <feGaussianBlur stdDeviation=".494" />
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
          <feColorMatrix values="0 0 0 0 0.203922 0 0 0 0 0.596078 0 0 0 0 0.854902 0 0 0 1 0" />
          <feBlend in2="shape" result="effect1_innerShadow_3466_12573" />
        </filter>
      </defs>
    </Icon>
  );
}
